"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Banner_1 = require("./Banner");
exports.default = Banner_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Banner/index.js
// module id = 1090
// module chunks = 8